import React from 'react';

function SpaceCollect() {
  const [username, setUsername] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');

  React.useEffect(() => {
    try {
      const raw = localStorage.getItem('sg_identity');
      if (raw) {
        const v = JSON.parse(raw);
        setUsername(v.username || '');
        setEmail(v.email || '');
      }
    } catch {}
  }, []);

  const onPlay = (e) => {
    e.preventDefault();
    if (!username || !email || !password) return;
    try {
      localStorage.setItem('sg_identity', JSON.stringify({ username, email }));
    } catch {}
    window.location.href = '/smart-games/space-collect/play';
  };

  return (
    <div className="bg-white">
      <style>{`
      @keyframes retroGradientShift {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
      .retro-title {
        background: linear-gradient(90deg, #ff00cc, #3333ff, #00e0ff, #00ff85, #ffdd00, #ff00cc);
        background-size: 400% 100%;
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        animation: retroGradientShift 8s ease infinite;
        text-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
      }
      `}</style>

      <section className="py-12 bg-gradient-to-b from-white to-gray-50" style={{ paddingTop: '200px' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="retro-title text-4xl sm:text-5xl font-extrabold tracking-tight">SPACE COLLECT</h1>
          <p className="mt-3 text-gray-600">Launch the game to play. Your results will appear on the leaderboard.</p>

          <div className="mt-6 rounded-lg border border-gray-200 p-6 bg-white">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username"
                className="w-full rounded-md border-gray-300 focus:border-emerald-500 focus:ring-emerald-500 px-3 py-2 text-sm"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full rounded-md border-gray-300 focus:border-emerald-500 focus:ring-emerald-500 px-3 py-2 text-sm"
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password (per-game)"
                className="w-full rounded-md border-gray-300 focus:border-emerald-500 focus:ring-emerald-500 px-3 py-2 text-sm"
              />
            </div>
            <div className="mt-4 flex items-center justify-between">
              <p className="text-xs text-gray-500">We will remember this on this device.</p>
              <button
                onClick={onPlay}
                className="inline-flex items-center justify-center rounded-md bg-emerald-600 px-5 py-2.5 text-white font-semibold hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500"
              >
                Play Now
              </button>
            </div>
          </div>

          <div className="mt-10">
            <h2 className="text-xl font-semibold text-gray-900">About the game</h2>
            <p className="mt-2 text-gray-600">
              Space Collect assesses quick decision-making and adaptive strategy via short challenges.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SpaceCollect;


